import { Component, OnInit, AfterViewInit, Input, ChangeDetectorRef, ViewChild } from "@angular/core";
import { IdentityStorage } from 'app/auth/_models/identity.storage';
import { AuthenticationResponse, AuthenticationService } from "app/auth/_services";
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from "@angular/router";
import { MediaMatcher } from "@angular/cdk/layout";
import { MatSidenav } from "@angular/material/sidenav";
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.sass'],
})
export class SidenavComponent implements OnInit {
  @ViewChild('sidenav') sidenav: MatSidenav;

  mostrarMenu: boolean = false;

  events: string[] = [];
  user: AuthenticationResponse;

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,
    private identityStorage: IdentityStorage,
    public router: Router,
    private authenticationService: AuthenticationService) {
    this.user = new AuthenticationResponse();
  }

  ngOnInit(): void {

  }

  logado(){
    this.user = this.authenticationService.userValue;
    this.checkPerfil();
    return this.router.url !== '/';
  }

  ngOnDestroy() {
    return this.authenticationService.isAuthenticated();
  }

  checkPerfil(){
    if(this.user == null){
      let u = this.authenticationService.getUserAuthData();
      if(u == null){
        this.user = new AuthenticationResponse();
        this.user.perfil = ''
      } else {
        this.user = new AuthenticationResponse();
        this.user.perfil = u.perfil;
      }

    }
  }

  fecharSidenav() {
    this.sidenav.close();
  }

}
